/**
 * 跳转到 Google 地图
 * @param options - 跳转选项
 * @param options.latitude - 纬度（可选）
 * @param options.longitude - 经度（可选）
 * @param options.address - 地址或位置名称（可选，用于搜索）
 * @param options.mode - 导航模式，可选 "search" 或 "navigate"（默认 "search"）
 */
export function openGoogleMap(options) {
  const { latitude, longitude, address, mode = "search" } = options;

  // 构造 Google 地图 URL
  let url = "https://www.google.com/maps/";

  if (
    mode === "navigate" &&
    latitude !== undefined &&
    longitude !== undefined
  ) {
    // 导航模式
    url += `dir/?api=1&destination=${latitude},${longitude}`;
  } else if (latitude !== undefined && longitude !== undefined) {
    // 搜索模式，优先使用坐标
    url += `search/?api=1&query=${latitude},${longitude}${
      address ? `&q=${encodeURIComponent(address)}` : ""
    }`;
  } else if (address) {
    // 搜索模式，使用地址
    url += `search/?api=1&query=${encodeURIComponent(address)}`;
  } else {
    throw new Error("必须提供坐标或地址以跳转到 Google 地图。");
  }
  // 在新窗口中打开链接
  window.open(url, "_blank");
}
